<div class="container my-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h2 class="fw-bold text-dark mb-1">Billing Details</h2>
      <p class="text-muted small mb-0">
        View comprehensive billing information
      </p>
    </div>
    <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">
      ← Back
    </button>
  </div>

  @if (billing) {
    <div>
      <div class="card shadow-sm mb-4 border-0">
        <div class="card-header bg-white border-bottom pb-3">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h4 class="fw-bold mb-1" style="color: #37bc6f">
                Billing No. {{ billing.billingNumber }}
              </h4>
              <small class="text-muted">{{
                billing.billingDate | date : "fullDate"
              }}</small>
            </div>
            <span
              class="badge fs-6 px-3 py-2 rounded-pill"
            [ngClass]="{
              'bg-success': !billing.isConsumable,
              'bg-secondary': billing.isConsumable
            }"
              >
              {{ billing.isConsumable ? "Consumable" : "Product Bill" }}
            </span>
          </div>
        </div>
        <div class="card-body">
          <div class="row g-4">
            <div class="col-md-3">
              <div class="border-start border-primary border-4 ps-3">
                <small class="text-muted text-uppercase fw-semibold"
                  >Grand Total</small
                  >
                  <p class="mb-0 fw-semibold h5 text-primary">
                    {{ formatCurrency(billing.grandTotal) }}
                  </p>
                </div>
              </div>
              <div class="col-md-3">
                <div class="border-start border-info border-4 ps-3">
                  <small class="text-muted text-uppercase fw-semibold"
                    >Sub Total</small
                    >
                    <p class="mb-0 fw-semibold">
                      {{ formatCurrency(billing.subTotal) }}
                    </p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="border-start border-success border-4 ps-3">
                    <small class="text-muted text-uppercase fw-semibold"
                      >Discount</small
                      >
                      <p class="mb-0 fw-semibold">
                        {{ formatCurrency(billing.discountAmount) }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="border-start border-warning border-4 ps-3">
                      <small class="text-muted text-uppercase fw-semibold"
                        >Total GST</small
                        >
                        <p class="mb-0 fw-semibold">
                          {{ formatCurrency(billing.gstAmount) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card shadow-sm border-0">
                <div
                  class="card-header bg-light d-flex justify-content-between align-items-center"
                  >
                  <h6 class="fw-bold mb-0 text-dark">📋 Items List</h6>
                  <span class="badge bg-secondary rounded-pill">
                    {{ billing?.products?.length || 0 }} Items
                  </span>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0">
                      <thead class="table-light">
                        <tr>
                          <th class="fw-semibold text-muted border-0 py-3">#</th>
                          <th class="fw-semibold text-muted border-0 py-3">
                            Product Name
                          </th>
                          <th class="fw-semibold text-muted border-0 py-3">SKU</th>
                          <th class="fw-semibold text-muted border-0 py-3 text-end">
                            Quantity
                          </th>
                          <th class="fw-semibold text-muted border-0 py-3 text-end">
                            Price
                          </th>
                          <th class="fw-semibold text-muted border-0 py-3 text-end">
                            Line Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of billing?.products; track item; let i = $index) {
                          <tr
                            class="border-bottom"
                            >
                            <td class="py-3 text-muted fw-semibold">{{ i + 1 }}</td>
                            <td class="py-3 fw-semibold">
                              {{ item?.variant?.variantName }}
                            </td>
                            <td class="py-3">
                              <span class="badge bg-light text-dark border">{{
                                item?.variant?.product?.sku
                              }}</span>
                            </td>
                            <td class="py-3 text-end">
                              <span
                                class="badge bg-info bg-opacity-25 text-info fw-semibold px-3 py-2"
                                >
                                {{ item.quantity }}
                              </span>
                            </td>
                            <td class="py-3 text-end">
                              {{ formatCurrency(item.price) }}
                            </td>
                            <td class="py-3 text-end">
                              {{ formatCurrency(item.price * item.quantity) }}
                            </td>
                          </tr>
                        }
                        @if (!billing?.products?.length) {
                          <tr>
                            <td colspan="6" class="text-center py-5">
                              <div class="text-muted">
                                <div class="display-4 mb-3">📦</div>
                                <p class="fw-semibold mb-1">No products available</p>
                                <small>This bill doesn't contain any products yet.</small>
                              </div>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (!billing && isLoading) {
            <div class="text-center py-5">
              <div class="spinner-border text-primary mb-3" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="text-muted fw-semibold">Loading billing details...</p>
            </div>
          }

          @if (!billing && !isLoading) {
            <div class="text-center py-5">
              <div class="display-4 text-danger mb-3">⚠️</div>
              <p class="text-muted fw-semibold">Billing record not found.</p>
              <p class="small text-muted">
                Please check the billing number and try again.
              </p>
            </div>
          }
        </div>
